import React from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { TurnrCard, TurnrCardContent } from "~/components/card/TurnrCard.jsx";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";

export default function IntegrationCard(props) {
    const { appProps, icon, title, subtitle, entity, onSuccess } = props;
    return (
        <TurnrGrid item xs={12} md={6} lg={4} xl={3}>
            <TurnrCard>
                <TurnrCardContent>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: 20,
                        }}
                    >
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                // justifyContent: "center",
                                alignItems: "center",
                                gap: 15,
                            }}
                        >
                            {icon}
                            <div>
                                <div
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 450,
                                    }}
                                >
                                    {title}
                                </div>
                                {subtitle && (
                                    <div
                                        style={{
                                            fontSize: "12px",
                                            color: "#888",
                                        }}
                                    >
                                        {subtitle}
                                    </div>
                                )}
                            </div>
                        </div>
                        <EntityActionsDotsMenu appProps={appProps} entity={entity} onSuccess={onSuccess} />
                    </div>
                </TurnrCardContent>
            </TurnrCard>
        </TurnrGrid>
    );
}
